/**
 * Configuración de tipos de imagen y buckets S3
 */

/**
 * Tipos de imagen soportados
 * - placeholder: ruta al placeholder (siempre se sirve desde bucket 'assets')
 * - bucket: tipo de bucket para la imagen real ('assets' para público, 'files' para privado)
 *
 * Por defecto las imágenes usan el bucket 'files' (s3FilesBasePath)
 * Solo el tipo 'asset' usa el bucket público 'assets' (s3AssetsBasePath)
 * Los placeholders siempre se sirven desde el bucket público 'assets'
 */
export const IMAGE_TYPES = {
  generic: { placeholder: 'placeholders/generic.png', bucket: 'files', placeholderBucket: 'assets' },
  promotion: { placeholder: 'placeholders/promotion.png', bucket: 'files', placeholderBucket: 'assets' },
  user: { placeholder: 'placeholders/user.png', bucket: 'files', placeholderBucket: 'assets' },
  product: { placeholder: 'placeholders/product.png', bucket: 'files', placeholderBucket: 'assets' },
  company: { placeholder: 'placeholders/company.png', bucket: 'files', placeholderBucket: 'assets' },
  file: { placeholder: null, bucket: 'files', placeholderBucket: 'assets' },
  asset: { placeholder: null, bucket: 'assets', placeholderBucket: 'assets' } // Bucket público para assets estáticos
}

/**
 * Tipo de acceso por bucket
 * - public: URL directa, no requiere autenticación
 * - private: Requiere presigned URL
 */
export const BUCKET_TYPES = {
  assets: 'public',
  files: 'private'
}

/**
 * Configuración del cache de presigned URLs
 */
export const CACHE_CONFIG = {
  defaultTTL: 3600,      // 1 hora para presigned URLs
  maxEntries: 200        // Máximo de entradas en cache
}
